import { useState, useEffect } from "react"
import { getImpactBannerDetails } from "../../API";
import { formatNumbers } from "../../utils/formatNumbers";

export default function ImpactBanner() {
  const [impactDetails, setImpactDetails] = useState({});
  useEffect(()=>{
    async function fetchData() {
      const res = await getImpactBannerDetails();
      console.log('Here', res);
      setImpactDetails(res||{});
    }
    fetchData()
  }, []);
    return <div className="container-fluid facts py-5">
    <div className="container py-5">
      <div className="row g-5">
        <div className="col-sm-12 col-lg-4 text-center wow fadeIn" data-wow-delay="0.1s">
          <h1 className="display-4 text-white" data-toggle="counter-up">{formatNumbers(impactDetails.PROJECT_REGIONS_DONE) || ""}</h1>
          <span className="fs-5 fw-semi-bold text-light">Project regions done around the globe</span>
        </div>
        <div className="col-sm-12 col-lg-4 text-center wow fadeIn" data-wow-delay="0.3s">
          <h1 className="display-4 text-white" data-toggle="counter-up">{formatNumbers(impactDetails.TREES_PLANTED) || ""}</h1>
          <span className="fs-5 fw-semi-bold text-light">Trees planted</span>
        </div>
        <div className="col-sm-12 col-lg-4 text-center wow fadeIn" data-wow-delay="0.5s">
          <h1 className="display-4 text-white" data-toggle="counter-up">{formatNumbers(impactDetails.CARBON_ABSORBED_BY_MANGROOVES) || ""}</h1>
          <span className="fs-5 fw-semi-bold text-light">Pounds of carbon absorbed by mangroves per year</span>
        </div>
      </div>
    </div>
  </div>
}